<template>
  <v-btn
    class="btn"
    :color="color"
    :disabled="disabled"
    large="large"
    :block="block"
    depressed="depressed"
    :type="type"
    :loading="loading"
    @click.native="onClick($event)"
  >
    <v-icon
      v-if="icon"
      left="left"
    >
      {{ icon }}
    </v-icon><span class="white--text btn--text">{{ text }}</span>
  </v-btn>
</template>

<script>
import BtnTemplate from './BtnTemplate.vue';

export default {
  name: 'BtnPrimary',
  extends: BtnTemplate,
  props: {
    color: {
      type: String,
      default: 'primary',
    },
  },
};
</script>

<style scoped>
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: #FFC4C6 !important;
  }
</style>
